// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a48c7084","239":"d593c945","453":"15e27b90","553":"0a1bae75"}[chunkId] + ".chunk.js";
};